<template>
  <div>
    <v-tooltip
      bottom
      max-width="500"
      :disabled="
        aiLimits.remaining_limit > 5 || aiLimits.remaining_limit === -1
      "
    >
      <template v-slot:activator="{ on }">
        <div v-on="on">
          <ui-button
            :disabled="aiLimits.remaining_limit === 0 || !canConfigureAiReply"
            :text="aiLimits.remaining_limit === 0"
            class="ai-settings-button"
            @click="$emit('open-ai-settings-dialog')"
          >
            <i
              class="ai-settings-button__icon icon icon-ai-settings-outlined"
            ></i>
            <div class="ai-settings-button__container">
              <div class="ai-settings-button__title">
                {{ buttonLabel }}
              </div>
              <div
                v-if="aiLimits.remaining_limit !== -1"
                class="ai-settings-button__data"
              >
                {{ $t("message.reviews.aiReply.repliesLeft") }}:
                <span
                  :class="{
                    'is-error': aiLimits.remaining_limit === 0
                  }"
                  >{{ aiLimits.remaining_limit }}/{{
                    aiLimits.monthly_limit
                  }}</span
                >
              </div>
            </div>
          </ui-button>
        </div>
      </template>
      <span>{{ aiTooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "ReviewAiLimitButton",
  props: {
    aiLimits: {
      type: Object,
      required: true
    },
    canConfigureAiReply: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    buttonLabel() {
      return this.canConfigureAiReply
        ? this.$t("message.reviews.aiReply.settingsAiReply")
        : this.$t("message.reviews.aiReply.generateWithAi");
    },
    aiTooltip() {
      return this.aiLimits.remaining_limit > 0 &&
        this.aiLimits.remaining_limit <= 5
        ? this.$t("message.reviews.aiReply.packetCloseToLimitTooltip")
        : this.$t("message.reviews.aiReply.outOfLimitTooltip");
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-settings-button {
  ::v-deep &.custom-btn.custom-btn--link .v-btn__content:before {
    display: none !important;
  }
  display: flex;
  align-items: center;

  &.v-btn[disabled="disabled"] {
    background: transparent !important;
    border: none !important;
  }

  &__icon {
    color: $grey-darker !important;
    @include font-size(24px);
    width: 24px;
    height: 24px;
  }

  &__container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;
  }

  &__title {
    @include font-size(12px);
    color: $grey-darker;
  }

  &__data {
    .is-error {
      color: $danger;
    }
    color: $gray;
    @include font-size(10px);
  }
}
</style>
